import containsRTLCharacters from "helpers/getContainsRtlChars.ts";

interface IContactNameElem {
  draggedOrHover: boolean;
  item: {
    contact_list_full_name: string;
  };
  email: string;
  name: string;
}

const ContactNameElem = ({
  draggedOrHover,
  item,
  email,
  name,
}: IContactNameElem) => {
  return draggedOrHover ? (
    <div>
      <div className="arrow-element" />
      {item.contact_list_full_name ? (
        <div>
          {item.contact_list_full_name}
          <br />
          {email}
        </div>
      ) : (
        <div>{email}</div>
      )}
    </div>
  ) : (
    <div
      style={{
        direction: containsRTLCharacters(name) ? "rtl" : "ltr",
      }}
    >
      {name}
    </div>
  );
};

export default ContactNameElem;
